import { Outlet } from 'react-router-dom';

const SubLayout = () => {
  return (
    <div className="min-h-[calc(100vh-8.25rem)]  bg-no-repeat md:bg-contain bg-hero-pattern pt-5 mb-5">
      <Outlet />
    </div>
  );
};

export default SubLayout;
